import React from 'react';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CompanyCard from '@components/ConnectionCard';

const Companies = ({ connections }) => (
    <Row className="connections-companies mx-1">
        {connections.map((connect) => (
            <Col key={connect.id} className="p-2" xs={12} sm={6} md={3}>
                <CompanyCard data={connect} tab="companies" />
            </Col>
        ))}
        {connections.length === 0 && <p className="dsl-b16 p-3">No companies</p>}
    </Row>
);

Companies.propTypes = {
    connections: PropTypes.array,
};

Companies.defaultProps = {
    connections: [],
};

export default Companies;
